import { useEffect } from 'react';

/* tslint:disable */
/* eslint-disable */
/** The effect that will be called once when component mounts **/
export const useMountEffect = (effect: () => (void | Promise<void>)) => useEffect(() => {
  effect();
}, []);
